import { sessionStore as sessionStorage } from "../local/device-store";

import React from "react";

export function canonicalPath(value: string): string {
  return value.replace(/\/+$/u, "") || "/";
}

export const path = () => canonicalPath(window.location.pathname);

export function navigate(to:string){sessionStorage.setItem("arabom:previous-route",path());const currentDepth=Number.isInteger(history.state?.arabomDepth)?Number(history.state.arabomDepth):0;history.pushState({arabomDepth:currentDepth+1}, "", to); dispatchEvent(new PopStateEvent("popstate")); window.scrollTo(0,0); }

export function A({to,children,className="",onOpen,...props}:{to:string;children:React.ReactNode;className?:string;onOpen?:()=>void; "aria-current"?:"page"}) {
  return <a href={to} className={className} {...props} onClick={e=>{onOpen?.();if(!e.metaKey&&!e.ctrlKey){e.preventDefault();navigate(to)}}}>{children}</a>;
}
